import type { QueryKey } from '@tanstack/react-query';

/**
 * Applied to every generated payroll query. The root `QueryClient` sets no defaults, so without
 * this each hook would restate its own caching policy — and a section that forgot to would retry
 * a failed payroll read three times before showing anything.
 *
 * Call-site options win, so a section that needs live data (`staleTime: 0`) still gets it.
 */
const FIVE_MINUTES = 1000 * 60 * 5;

const payrollQueryDefaults = <T extends { queryKey: QueryKey }>(options: T): T => ({
    staleTime: FIVE_MINUTES,
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
});

export default payrollQueryDefaults;
